import React from 'react';

/**
 * Sticky overview of how many units of each article the whole Retoure returns,
 * plus the comment fields and submit button. Unlike the outbound summary there
 * is no warehouse-availability column — a return adds stock back rather than
 * consuming it; the per-line cap is the delivered quantity instead.
 *
 * `summaryDetails` entries: { articleId, articleName, total }
 */
const ReturnSummaryPanel = ({
  summaryDetails = [],
  overReturned,
  isLoading,
  onSubmit,
  comment = '',
  onCommentChange,
  noteComment = '',
  onNoteCommentChange,
}) => {
  const totalUnits = summaryDetails.reduce((sum, d) => sum + d.total, 0);

  return (
    <div className='card position-sticky' style={{ top: '1rem' }}>
      <div className='card-header fw-bold'>Retoure-Übersicht</div>
      <div className='card-body'>
        {summaryDetails.length === 0 ? (
          <p className='text-muted mb-0'>
            Noch keine Mengen erfasst. Rücknahme pro Artikel erscheint hier.
          </p>
        ) : (
          <table className='table table-sm align-middle mb-0'>
            <thead>
              <tr className='text-muted small'>
                <th>Artikel</th>
                <th className='text-end'>Retoure</th>
              </tr>
            </thead>
            <tbody>
              {summaryDetails.map((detail) => (
                <tr key={detail.articleId}>
                  <td>{detail.articleName}</td>
                  <td className='text-end text-nowrap'>{detail.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className='card-footer'>
        <div className='mb-2 text-start'>
          <label htmlFor='returnComment' className='form-label small mb-1'>
            Kommentar/Hinweis{' '}
            <span className='text-muted'>
              (optional, nur im System sichtbar)
            </span>
          </label>
          <textarea
            id='returnComment'
            className='form-control'
            rows={2}
            maxLength={255}
            value={comment}
            onChange={(e) => onCommentChange(e.target.value)}
            placeholder='z. B. Hinweis zur Retoure'
          />
        </div>
        <div className='mb-2 text-start'>
          <label htmlFor='returnNoteComment' className='form-label small mb-1'>
            Lieferschein-Hinweis{' '}
            <span className='text-muted'>
              (wird auf den Lieferschein/PDF gedruckt)
            </span>
          </label>
          <textarea
            id='returnNoteComment'
            className='form-control'
            rows={2}
            maxLength={255}
            value={noteComment}
            onChange={(e) => onNoteCommentChange(e.target.value)}
            placeholder='z. B. Hinweis, der auf dem Lieferschein erscheint'
          />
        </div>
        <div className='text-muted small mb-2'>
          Σ {summaryDetails.length} Positionen · {totalUnits} Einheiten
        </div>
        <button
          className='btn btn-success w-100'
          onClick={onSubmit}
          disabled={overReturned || isLoading}
        >
          Retoure anlegen
        </button>
        {overReturned && (
          <div className='text-danger small mt-2'>
            Mindestens ein Artikel überschreitet die gelieferte Menge.
          </div>
        )}
      </div>
    </div>
  );
};

export default ReturnSummaryPanel;
